export const colValueDefault = {
  classes: "w-10",
  dataField: "valueDefault",
  text: "Value",
};
export const colValue = {
  classes: "w-10",
  dataField: "value",
  text: "Value",
};
